import { FC } from "react";

import { TInvestigationSwatch } from "../investigation.models";
import { lineDashStyle } from "../investigation.utils";
import {
  FilterSwatchDotStyled,
  FilterSwatchLineStyled,
} from "../investigation.workspace.styled";

/** The colored swatch (dot or line) shown inside a map filter chip; nothing for "none". */
export const FilterSwatch: FC<{
  swatch: TInvestigationSwatch;
  color: string;
  active: boolean;
}> = ({ swatch, color, active }) => {
  if (swatch === "none") {
    return null;
  }

  if (swatch === "dot") {
    return <FilterSwatchDotStyled $color={color} $active={active} />;
  }

  return (
    <FilterSwatchLineStyled
      $color={color}
      $active={active}
      $dash={lineDashStyle(swatch)}
    />
  );
};
